import React from "react";
import PaymentLayout from "../../layouts/PaymentLayout";

export default function Payment() {
    return (
        <div className="w-full h-full">
            <PaymentLayout />
        </div>
    );
}
